import { logEvent } from '@/lib/stats'

export function logCTAEvent(label: string): void {
  logEvent({
    ga: {
      category: 'Course Detail-CTA',
      action: 'Click Purchase',
      label,
    },
  })
}

export function logPreviewEvent(label: string): void {
  logEvent({
    ga: {
      category: 'Course Detail-Free trial',
      action: 'Click free trial',
      label,
    },
  })
}
